export enum PDFColors {
  pdfGrey = '#B6B6B6',
  pdfDarkGrey = '#585858',
  pdfWhite = '#FFFFFF',
  pdfBlack = '#2f2f2f',
  pdfRed = '#CF4520',
}

export const MakeRed = '[MAKE_ME_RED]';
